// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__1-PZR","validationTips":"StatementDescriptor_validationTips__1PkOu"};